import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useStoredKey, setStoredKey } from '../../hooks/useStoredKey';
import { Wrapper, Content, Close } from './styles';
const NotificationBar = ({ storageKey = 'default', color = 'grey', dismissible = true, bannerCount = 0, width = 1280, children, ...props }) => {
    const [visible, setVisible] = useState(false);
    const [closedCount, setClosedCount] = useState(0);
    // Tokenize the storageKey for use in local and session storage
    const key = useMemo(() => {
        const tokenizedKey = storageKey.toLowerCase().trim().replace(/\s/g, '-');
        return `ui-kit-notification-bar-${tokenizedKey}`;
    }, [storageKey]);
    // Check if the banner should be visible on component mount
    useEffect(() => {
        try {
            // Check if the banner has already been closed today
            const closedToday = useStoredKey(`${key}-closed`);
            // Check the number of times the banner has been closed
            const count = parseInt(localStorage.getItem(`${key}-count`) || '0', 10);
            setClosedCount(count);
            // If it hasn't been closed today, and it's been closed fewer times than the banner count, show the banner
            if (!closedToday && (!bannerCount || count < bannerCount))
                setVisible(true);
        }
        catch (e) {
            console.warn(`NotificationBar: could not use storage. ${e}`);
        }
    }, []);
    // Hide the banner on close button press
    const handleClose = (event) => {
        event.preventDefault();
        // Increment the number of times the banner has been closed
        const count = closedCount + 1;
        setClosedCount(count);
        // Hide the banner
        setVisible(false);
        // Update the values in storage
        try {
            if (bannerCount)
                localStorage.setItem(`${key}-count`, `${count}`);
            // Do not show the banner again for 12 hours
            setStoredKey(`${key}-closed`, 12 * 60 * 60 * 1000);
        }
        catch (e) {
            console.warn(`NotificationBar: could not use storage. ${e}`);
        }
    };
    return (_jsxs(Wrapper, { "data-ui-kit-visible": visible, "data-ui-kit-color": color, ...props, children: [_jsx(Content, { style: { width: `${width - 32}px` }, children: children }), dismissible && (_jsx(Close, { "aria-label": "Close", tabIndex: 0, onClick: handleClose, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", children: _jsx("path", { fill: "currentColor", d: "M13.2 4.027 12.173 3 8.1 7.073 4.027 3 3 4.027 7.073 8.1 3 12.173 4.027 13.2 8.1 9.127l4.073 4.073 1.027-1.027L9.127 8.1 13.2 4.027z" }) }) }))] }));
};
export default NotificationBar;
//# sourceMappingURL=NotificationBar.js.map